import type { ReactNode } from "react";
import PrivateRoute from "./PrivateRoute";

interface WrapPrivateRouteProps {
  element: ReactNode;
  role?: string | string[];
}

export const WrapPrivateRoute = ({ element, role }: WrapPrivateRouteProps) => {
  return <PrivateRoute role={role}>{element}</PrivateRoute>;
};
